import React from 'react'
import { Button, type IButtonProps } from 'shared/ui'
import { type ITextFieldProps, TextField } from 'shared/ui/TextField'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard.tsx'
import styles from './styles.module.scss'

export const EnrollByWebhookCopyInput = ({
  webhookUrl,
  textFieldSize = 'medium',
  copyBtnSize = 'large',
}: {
  webhookUrl?: string
  textFieldSize?: ITextFieldProps['size']
  copyBtnSize?: IButtonProps['size']
}) => {
  const { onCopy, copied } = useCopyToClipboard(webhookUrl || '', {
    showToast: true,
    toastTitle: 'Link copied',
    toastType: 'success',
  })

  return (
    <div className={styles.copyInput}>
      <TextField variant={'stroke'} size={textFieldSize} readOnly value={webhookUrl} />
      <Button
        icon={copied ? undefined : 'copy'}
        text={copied ? 'Copied' : 'Copy'}
        typeBtn='contained'
        contained='tertiary'
        size={copyBtnSize}
        onClick={onCopy}
      />
    </div>
  )
}
